import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';

const View_Login = ({ setAuthen }) => {
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('72565123');
  const [error, setError] = useState('');

  const handleLogin = () => {
    if (!username || !password) {
      setError('Please enter both username and password');
      return;
    }

    if (username === 'admin' && password === '72565123') {
        setAuthen('logged');  
    } else {
      setError('Invalid username or password');
    }
  };



  return (
    <>
      <div className='bg-theme-primary-2 py-2 flex-center'>
        <div className='container-xl bg-white border border-theme-primary-4 row shadow '>
          <div className=''>
            <div id="login-form">
              <h4 className='font-primary mb-2 mb-lg-3 text-center text-theme-primary-17'>Client Login</h4>
              <label>
                Email ID/Username:
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className={`w-100 ${error && !username ? 'invalid' : ''}`}
                />
              </label>
              <br />
              <label>
                Password:
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className={`w-100 ${error && !password ? 'invalid' : ''}`}
                />
              </label>
              <label className='text-black-5 d-none'>
                <input type="checkbox" className='me-1' checked />Remember Password
              </label>
              <br />
              <div className='flex-center justify-content-between'>
                <button onClick={handleLogin}>Login</button>
                <p className='mt-2'><a href="mailto:admin@ayatacommerce.com">Request Password?</a></p>
              </div>
              <div className=''>{error && <p className="bg-theme-pink text-white p-2 error-message fw-bold">{error}</p>}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default View_Login;